import { normalizeLocale, sourceLocale } from "@hallyulytics/i18n";
import type { LoaderFunctionArgs, RouteObject } from "react-router";
import { HomePage } from "./pages/HomePage";
export async function homeLoader({ request }: LoaderFunctionArgs) {
  return { locale: normalizeLocale(request.headers.get("x-hallyulytics-locale")) ?? sourceLocale };
}
export const routes: RouteObject[] = [{ path: "/", loader: homeLoader, Component: HomePage }];
